import script from "./TheNotesList.vue?vue&type=script&setup=true&lang=js"
export * from "./TheNotesList.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__